import { backendAPI } from '../../helper/apis';


export function updateDynamicPrices(params) {
  return backendAPI.put(`/dynamic_price/${params.serviceId}/${params.areaId}/${params.polygonId}`, params.prices?.filter(price => price.price !== null));
}